import fetchJSON from '@api/api_helper';

const get = (sectionKey, params, options = {}) => {
  const { searchQuery, resourceType, resourceKey, onlyKeys } = options;
  let url = '/api/v4';
  if (resourceType) {
    url += `/${resourceType}/${resourceKey}`;
  }

  url += `/sections/${sectionKey}/asset${onlyKeys ? '_keys' : 's'}`;
  if ((searchQuery || params.labelKeys) && !onlyKeys) {
    url += '/search';
  }

  const method = searchQuery || params.labelKeys ? 'POST' : 'GET';

  const fetchController = options.fetchController || (() => {});

  const body = {};
  if (searchQuery) {
    body.search = params.search;
    delete params.search; // eslint-disable-line no-param-reassign
  }

  if (params.labelKeys) {
    body.label_keys = params.labelKeys;
    delete params.labelKeys; // eslint-disable-line no-param-reassign
  }

  return fetchJSON(url, {
    method,
    params,
    body: Object.keys(body).length ? body : undefined,
  }, fetchController).then((response) => {
    if (!response.meta) {
      return {
        assets: response.data,
      };
    }

    return {
      assets: response.data,
      total: response.meta.total_count,
      totalPages: response.meta.total_pages,
      currentPage: response.meta.current_page,
    };
  });
};

export default get;
